<template>
  <QBtn
    v-bind="$attrs"
    :data-cy="dataCy"
    :label="label"
    :disabled="disabled"
    :color="color"
    :flat="flat"
    :outline="outline"
    :class="[
      'tw-min-w-24',
      { 'block': block },
      { '!tw-min-w-fit': fitContent },
      { 'no-label': label === '' },
    ]"
    no-caps
    :size="size"
  >
    <div class="tw-flex tw-items-center tw-justify-center">
      <QIcon
        v-if="icon"
        :name="icon"
        :size="iconSize"
        :class="iconClass"
      />
      <span
        class="tw-text-dt-button tw-whitespace-nowrap"
      >
        <slot />
      </span>
    </div>
  </QBtn>
</template>

<script setup lang="ts">
defineProps({
  icon: {
    type: String,
    default: '',
  },
  dataCy: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  block: {
    type: Boolean,
    default: false,
  },
  flat: {
    type: Boolean,
    default: false,
  },
  fitContent: {
    type: Boolean,
    default: false,
  },
  outline: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '',
  },
  iconSize: {
    type: String,
    default: 'xs',
  },
  iconClass: {
    type: String,
    default: 'tw-mr-2',
  },
})
</script>
